// Collection cards: quantity stepper; the button label follows price x quantity.
(() => {
  if (window.kbCardAtcInit) return;
  window.kbCardAtcInit = true;

  const clamp = (n) => Math.min(99, Math.max(1, Number.isFinite(n) ? Math.round(n) : 1));

  const format = (cents, currency) => {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(Number.isInteger(amount) ? 0 : 2);
    }
  };

  const update = (form, qty) => {
    const input = form.querySelector('[data-kb-atc-qty]');
    const add = form.querySelector('[data-kb-atc-add]');
    const label = form.querySelector('[data-kb-atc-amt]');
    if (!input || !add || !label) return;
    input.value = qty;
    const minus = form.querySelector('[data-kb-atc-step="-1"]');
    if (minus && minus.disabled !== qty <= 1) minus.disabled = qty <= 1;
    const text = ' - ' + format(Number(add.dataset.price) * qty, add.dataset.currency);
    if (label.textContent !== text) label.textContent = text;
  };

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-kb-atc-step]');
    if (!step) return;
    const form = step.closest('form');
    const input = form && form.querySelector('[data-kb-atc-qty]');
    if (!input) return;
    event.preventDefault();
    update(form, clamp(parseInt(input.value, 10) + Number(step.dataset.kbAtcStep)));
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-kb-atc-qty]');
    if (input) update(input.form, clamp(parseInt(input.value, 10)));
  });

  const init = (root) => root.querySelectorAll('[data-kb-atc-qty]').forEach((input) => update(input.form, clamp(parseInt(input.value, 10))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  // Filtering / sorting / pagination re-renders the grid
  const grid = document.getElementById('ProductGridContainer') || document.body;
  new MutationObserver(() => init(grid)).observe(grid, { childList: true, subtree: true });
})();
